import React from 'react'
import Layout from '../../include/layout'
import EditVehicleInformationView from './views/EditVehicleInformationView'
import useAddVehicleInformation from "../addVehicleInformation/hooks/addVehicleInformation.hook";

const EditVehicleInformation = () => {
    const editVehicleHook = useAddVehicleInformation();

    if(editVehicleHook?.loading) {
        return <></>
    } else {
    return (
        <Layout>
            <EditVehicleInformationView {...editVehicleHook} />
        </Layout>
    )
}
}

export default EditVehicleInformation